import { PostTextEditorModule } from './../post-text-editor/post-text-editor.module';
import { SharedModule } from './../../../pipes/shared-module';
import { DxButtonModule, DxTextBoxModule, DxCheckBoxModule, DxTextAreaModule, DxHtmlEditorModule ,DxDropDownBoxModule,DxDataGridModule} from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostCardComponent } from './post-card.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
	declarations: [PostCardComponent],
	exports: [PostCardComponent],
  imports: [
		CommonModule,
		SharedModule,
		ReactiveFormsModule,
		PostTextEditorModule,
		DxButtonModule,
		DxTextBoxModule,
		DxCheckBoxModule,
		DxTextAreaModule,DxHtmlEditorModule,DxDropDownBoxModule,DxDataGridModule
  ]
})
export class PostCardModule { }
